/**
 * Una etiqueta arriba y un valor abajo.
 *
 * Es lo que reemplazó a las columnas cuando el historial y las programaciones dejaron de
 * ser tablas: en una tabla el encabezado dice qué es cada número una sola vez, y en una
 * tarjeta ese encabezado tiene que viajar con el dato. Sin esto, "232" y "4" son dos
 * números sueltos.
 */

import { Box, Text } from '@nimbus-ds/components';
import type { ReactElement, ReactNode } from 'react';

export function Dato({
  etiqueta,
  children,
}: {
  readonly etiqueta: string;
  readonly children: ReactNode;
}): ReactElement {
  return (
    <Box display="flex" flexDirection="column" gap="0-5">
      <Text fontSize="caption" color="neutral-textLow">
        {etiqueta}
      </Text>
      {typeof children === 'string' ? <Text fontWeight="medium">{children}</Text> : children}
    </Box>
  );
}
